import React from 'react';
import Modal from '../../UI/Modal/Modal';
import Button from '../../UI/Button/Button';
import './PriceChangeConfirmModal.css';

const PriceChangeConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  type,
  percentage,
  sampleProduct
}) => {
  if (!sampleProduct) return null;

  const currentPrice = parseFloat(sampleProduct.variants[0].price);
  const factor = type === 'increase' ? (1 + percentage / 100) : (1 - percentage / 100);
  const newPrice = (currentPrice * factor).toFixed(2);
  
  const actionText = type === 'increase' ? 'artırılacak' : 'azaltılacak';
  const actionColor = type === 'increase' ? 'text-green-600' : 'text-red-600';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Fiyat Değişikliği Onayı">
      <div className="price-change-confirm-content">
        <p className="confirm-message">
          Seçili ürünlerin fiyatları <strong>%{percentage}</strong> oranında {actionText}.
        </p>
        
        <div className="sample-product-info">
          <h4>Örnek Değişiklik:</h4>
          <div className="sample-product-name">{sampleProduct.title}</div>
          
          <div className="price-comparison">
            <div className="current-price">
              <span className="price-label">Mevcut Fiyat:</span>
              <span className="price-value">{currentPrice.toFixed(2)} ₺</span>
            </div>
            
            <div className="arrow">→</div>
            
            <div className="new-price">
              <span className="price-label">Yeni Fiyat:</span>
              <span className={`price-value ${actionColor}`}>{newPrice} ₺</span>
            </div>
          </div>
        </div>
        
        <div className="warning-message">
          Bu işlem seçili tüm ürünlerin fiyatlarını değiştirecektir.
        </div>
        
        <div className="modal-actions">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading !== null}
          >
            İptal
          </Button>
          
          <Button
            variant={type === 'increase' ? 'success' : 'danger'}
            onClick={onConfirm}
            loading={loading !== null}
          >
            Onayla ve Uygula
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PriceChangeConfirmModal;
